import * as React from 'react'
import type { TLinkElement } from 'platejs'
import { PlateElement } from 'platejs/react'
import type { PlateElementProps } from 'platejs/react'
import { useLink } from '@platejs/link/react'
import { clsx } from 'clsx'

import styles from './LinkElement.module.css'

const LinkElement = React.forwardRef<
  HTMLAnchorElement,
  PlateElementProps<TLinkElement>
>(({ children, className, element, ...props }, ref) => {
  const { props: linkProps } = useLink({ element })
  const configuredClassName =
    'className' in linkProps && typeof linkProps.className === 'string'
      ? linkProps.className
      : undefined

  return (
    <PlateElement
      {...props}
      {...linkProps}
      ref={ref}
      as="a"
      className={clsx(styles.link, configuredClassName, className)}
      element={element}
    >
      {children}
    </PlateElement>
  )
})

LinkElement.displayName = 'RichTextField.LinkElement'

export { LinkElement }
